import { render, staticRenderFns } from "./TrainingStepTextAnnotation.vue?vue&type=template&id=1347a939&scoped=true&"
import script from "./TrainingStepTextAnnotation.vue?vue&type=script&lang=js&"
export * from "./TrainingStepTextAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStepTextAnnotation.vue?vue&type=style&index=0&id=1347a939&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347a939",
  null
  
)

export default component.exports